export default __webpack_public_path__ + "static/Main-Logo-b3dcac805162ac2625124260ba92e2ee.svg";